import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { endpoints } from '../../utils/constants';
import axios from '../../axiosConfig';

export const generateIdu = createAsyncThunk(
  'promoter/generateIdu',
  async (body, { rejectWithValue }) => {
    try {
      const requestBody = {
        line: body.phoneNumber,
        mail: body.email,
        documentType: body.documentType,
        documentNumber: body.documentNumber,
      };
      const response = await axios.post(endpoints.GENERATE_IDU, requestBody);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Error desconocido' });
    }
  },
);

export const checkProcessStatus = createAsyncThunk(
  'promoter/checkProcessStatus',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(endpoints.CHECK_PROCESS_STATUS, body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Error desconocido' });
    }
  },
);

const initialState = {
  documentType: '',
  documentNumber: '',
  phoneNumber: '',
  email: '',
  idu: '',
};

const promoterSlice = createSlice({
  name: 'promoter',
  initialState: {
    data: initialState,
    loading: false
  },
  reducers: {
    setPromoterData: (state, action) => {
      state.data.documentType = action.payload.documentType;
      state.data.documentNumber = action.payload.documentNumber;
      state.data.phoneNumber = action.payload.phoneNumber;
      state.data.email = action.payload.email;
    },
    setIdu: (state, action) => {
      state.data.idu = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateIdu.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateIdu.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(generateIdu.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setPromoterData, setIdu } = promoterSlice.actions;

export default promoterSlice.reducer;
